// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://coming-soon-webpage-production.up.railway.app'
    : 'http://localhost:3001'
  );

export const API_ENDPOINTS = {
  JOIN_WAITLIST: `${API_BASE_URL}/api/join-waitlist`,
  CONTACT: `${API_BASE_URL}/api/contact`,
  WAITLIST_STATS: `${API_BASE_URL}/api/waitlist-stats`,
  CONTACT_MESSAGES: `${API_BASE_URL}/api/contact-messages`,
  UNSUBSCRIBE: `${API_BASE_URL}/api/unsubscribe`,
};

export default API_ENDPOINTS;
